export type SecretIdentity = {
  name: string
  key: IdentityKey
  superpower: string
}

export const heroImages = {
  image_1: 'https://res.cloudinary.com/almanac/image/upload/v1710334137/blaze_assets/hero_avatars/image_1_yd1cwd.png',
  image_2: 'https://res.cloudinary.com/almanac/image/upload/v1710333987/blaze_assets/hero_avatars/image_2_gae7cc.png',
  image_3: 'https://res.cloudinary.com/almanac/image/upload/v1710334161/blaze_assets/hero_avatars/image_3_pbvqmw.png',
  image_4: 'https://res.cloudinary.com/almanac/image/upload/v1710333960/blaze_assets/hero_avatars/image_4_j5nt9r.png',
  image_5: 'https://res.cloudinary.com/almanac/image/upload/v1710333952/blaze_assets/hero_avatars/image_5_f09v8o.png',
  image_6: 'https://res.cloudinary.com/almanac/image/upload/v1710334144/blaze_assets/hero_avatars/image_6_oakjl7.png',
  image_7: 'https://res.cloudinary.com/almanac/image/upload/v1710333915/blaze_assets/hero_avatars/image_7_himnyd.png',
  image_8: 'https://res.cloudinary.com/almanac/image/upload/v1710334171/blaze_assets/hero_avatars/image_8_ubaduk.png',
  image_9: 'https://res.cloudinary.com/almanac/image/upload/v1710333836/blaze_assets/hero_avatars/image_9_wwvgwr.png',
  image_10: 'https://res.cloudinary.com/almanac/image/upload/v1710333756/blaze_assets/hero_avatars/image_10_nzmnlh.png',
  image_11: 'https://res.cloudinary.com/almanac/image/upload/v1710334152/blaze_assets/hero_avatars/image_11_kvgc6b.png',
  image_12: 'https://res.cloudinary.com/almanac/image/upload/v1710333944/blaze_assets/hero_avatars/image_12_kz83yi.png',
  image_13: 'https://res.cloudinary.com/almanac/image/upload/v1710334195/blaze_assets/hero_avatars/image_13_howiw9.png',
  image_14: 'https://res.cloudinary.com/almanac/image/upload/v1711302133/blaze_assets/hero_avatars/image_14_k6atyf.png',
  image_15: 'https://res.cloudinary.com/almanac/image/upload/v1711302133/blaze_assets/hero_avatars/image_15_ahpdij.png',
}

export const heroImagesBack = {
  image_1:
    'https://res.cloudinary.com/almanac/image/upload/v1710411754/blaze_assets/hero_avatars/image_1_back_jwuwwx.png',
  image_2:
    'https://res.cloudinary.com/almanac/image/upload/v1710411762/blaze_assets/hero_avatars/image_2_back_hixclh.png',
  image_3:
    'https://res.cloudinary.com/almanac/image/upload/v1710414028/blaze_assets/hero_avatars/image_3_back_qrmlb8.png',
  image_4:
    'https://res.cloudinary.com/almanac/image/upload/v1710411767/blaze_assets/hero_avatars/image_4_back_vf40k0.png',
  image_5:
    'https://res.cloudinary.com/almanac/image/upload/v1710411694/blaze_assets/hero_avatars/image_5_back_svjskn.png',
  image_6:
    'https://res.cloudinary.com/almanac/image/upload/v1710411700/blaze_assets/hero_avatars/image_6_back_lxwzrb.png',
  image_7:
    'https://res.cloudinary.com/almanac/image/upload/v1710411767/blaze_assets/hero_avatars/image_7_back_cmnrzu.png',
  image_8:
    'https://res.cloudinary.com/almanac/image/upload/v1710411767/blaze_assets/hero_avatars/image_8_back_oqooyn.png',
  image_9:
    'https://res.cloudinary.com/almanac/image/upload/v1710411756/blaze_assets/hero_avatars/image_9_back_ti1z03.png',
  image_10:
    'https://res.cloudinary.com/almanac/image/upload/v1710411759/blaze_assets/hero_avatars/image_10_back_b71zq0.png',
  image_11:
    'https://res.cloudinary.com/almanac/image/upload/v1710411753/blaze_assets/hero_avatars/image_11_back_wd1q6c.png',
  image_12:
    'https://res.cloudinary.com/almanac/image/upload/v1710411760/blaze_assets/hero_avatars/image_12_back_x4unzq.png',
  image_13:
    'https://res.cloudinary.com/almanac/image/upload/v1710411707/blaze_assets/hero_avatars/image_13_back_di14w8.png',
  image_14:
    'https://res.cloudinary.com/almanac/image/upload/v1710411763/blaze_assets/hero_avatars/image_14_back_fvvr9e.png',
  image_15:
    'https://res.cloudinary.com/almanac/image/upload/v1710411752/blaze_assets/hero_avatars/image_15_back_hgpshf.png',
}

export const heroColors = {
  image_1: '#0090db',
  image_2: '#DA9D00',
  image_3: '#0090db',
  image_4: '#DA9D00',
  image_5: '#04AF00',
  image_6: '#04AF00',
  image_7: '#DA9D00',
  image_8: '#DA9D00',
  image_9: '#04AF00',
  image_10: '#DA9D00',
  image_11: '#0090db',
  image_12: '#0090db',
  image_13: '#0090db',
  image_14: '#DA9D00',
  image_15: '#0090db',
}

export const heroBgColors = {
  image_1: 'var(--blaze-Baby-Blue, #BEE9FC)',
  image_2: '#FCF6BE',
  image_3: 'var(--blaze-Baby-Blue, #BEE9FC)',
  image_4: '#FCF6BE',
  image_5: '#C7FCBE',
  image_6: '#C7FCBE',
  image_7: '#FCF6BE',
  image_8: '#FCF6BE',
  image_9: '#C7FCBE',
  image_10: '#FCF6BE',
  image_11: 'var(--blaze-Baby-Blue, #BEE9FC)',
  image_12: 'var(--blaze-Baby-Blue, #BEE9FC)',
  image_13: 'var(--blaze-Baby-Blue, #BEE9FC)',
  image_14: '#FCF6BE',
  image_15: 'var(--blaze-Baby-Blue, #BEE9FC)',
}

export type ImageKey = keyof typeof heroImages

export const backgroundColors = ['var(--blaze-pale-green)', 'var(--blaze-pale-blue)', 'var(--blaze-pale-yellow)']

export const foregroundColors = [
  'var(--blaze-pale-green)',
  'var(--blaze-pale-blue)',
  'var(--blaze-pale-yellow)',
  'var(--blaze-dark-green)',
  'var(--blaze-dark-yellow)',
  'var(--blaze-dark-blue)',
]

export type IdentityKey =
  | 'analytics_avenger'
  | 'branding_barista'
  | 'copywriting_crusader'
  | 'captain_content'
  | 'crusher_of_quotas'
  | 'data_daredevil'
  | 'messaging_maestro'
  | 'storytelling_sage'
  | 'testing_titan'
  | 'viral_virtuoso'

export type Identities = {
  [key in IdentityKey]: SecretIdentity
}

export const identities: Identities = {
  analytics_avenger: {
    name: 'Analytics Avenger',
    superpower: 'Fires arrows of KPIs, always hitting the ROI target. Bullseye!',
    key: 'analytics_avenger',
  },
  branding_barista: {
    name: 'Branding Barista',
    superpower: 'Brews more buzz than a caffeine jolt. Truly unbeanlievable.',
    key: 'branding_barista',
  },
  copywriting_crusader: {
    name: 'Copywriting Crusader',
    superpower: 'Crafts calls-to-action that cut through indifference.',
    key: 'copywriting_crusader',
  },
  captain_content: {
    name: 'Captain Content',
    superpower: 'Spins lackluster products into legendary, captivating tales.',
    key: 'captain_content',
  },
  crusher_of_quotas: {
    name: 'Crusher of Quotas',
    superpower: 'Knocks out super-charged content in a flash. Kapow!',
    key: 'crusher_of_quotas',
  },
  data_daredevil: {
    name: 'Data Daredevil',
    superpower: 'Sifts through seas of stats to find nuggets of gold.',
    key: 'data_daredevil',
  },
  messaging_maestro: {
    name: 'Messaging Maestro',
    superpower: 'Sets the tempo for unbeatable marketing materials.',
    key: 'messaging_maestro',
  },
  storytelling_sage: {
    name: 'Storytelling Sage',
    superpower: 'Transforms mundane copy into mesmerizing myths.',
    key: 'storytelling_sage',
  },
  testing_titan: {
    name: 'Testing Titan',
    superpower: 'Cooks up the formula for unbreakable campaigns.',
    key: 'testing_titan',
  },
  viral_virtuoso: {
    name: 'Viral Virtuoso',
    superpower: 'Creates trending content faster than a speeding bullet.',
    key: 'viral_virtuoso',
  },
}
